const validator = {
    hm: null,
    rules: {},

    loadRules: function (component, rules) {
        if (typeof this.rules[component.formId] === typeof undefined) {
            this.rules[component.formId] = {};
        }

        if (typeof this.rules[component.formId][component.id] === typeof undefined) {
            this.rules[component.formId][component.id] = {}
        }

        this.rules[component.formId][component.id] = Object.assign(this.rules[component.formId][component.id], rules);
    },

    getRules: function (formId, componentId) {
        if (typeof this.rules[formId] === typeof undefined) {
            return [];
        } else {
            if (typeof this.rules[formId][componentId] === typeof undefined) {
                return [];
            } else {
                return this.rules[formId][componentId];
            }
        }
    },

    validateComponent: function (componentId) {
        let valid = true;
        let component = this.hm.app.components[componentId];
        let formId = component.formId;
        let rules = typeof this.rules[formId] !== typeof undefined && typeof this.rules[formId][componentId] !== typeof undefined ? this.rules[formId][componentId]: {};
        let value = component.getValue();

        this.resetValidation(component);

        for (let ruleName in rules) {
            let ruleConfig = rules[ruleName];
            let ruleValid = true;
            let text = '';

            switch (ruleName) {
                case 'email':
                    if (value.length > 0) {
                        //let reg = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");

                        const reg = /^(?:[a-zA-Z0-9_'^&/+-])+(?:\.(?:[a-zA-Z0-9_'^&/+-])+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

                        if (value !== '' && !reg.test(value)) {
                            ruleValid = false;
                        }
                    }
                    break;

                case 'numeric':
                    if (value.length > 0) {
                        value = value.replace(/,/g, '.');
                        component.setValue(value);

                        if (isNaN(value)) {
                            ruleValid = false;
                        }
                    }
                    break;

                case 'different':
                    if (value.length > 0) {
                        if (value !== ruleConfig.compareVal) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_different.text.replace('[replace1]', ruleConfig.compareVal);
                        }
                    }
                    break;

                case 'equal':
                    if (value.length > 0) {
                        if (value === ruleConfig.compareVal) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_equal.text.replace('[replace1]', ruleConfig.compareVal);
                        }
                    }
                    break;

                case 'regex':
                    if (value.length > 0) {
                        let reg = new RegExp(ruleConfig.value);

                        if (!reg.test(value)) {
                            ruleValid = false;
                        }
                    }
                    break;

                case 'required':
                    let reg = new RegExp(/[a-zA-Z0-9]/);

                    if (!reg.test(value)) {
                        ruleValid = false;
                    }
                    break;


                case 'min_length':
                    if (value.length > 0) {
                        let min_length = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;

                        if (value.length < min_length) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_min_length.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'max_length':
                    if (value.length > 0) {
                        let max_length = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;
                        if (value.length > max_length && max_length > 0) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_max_length.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'min_numbers':
                    if (value.length > 0) {
                        let minNoChars = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;
                        let matches = value.match(/[0-9]/g);
                        let noMatches = matches !== null ? matches.length : 0;

                        if (noMatches < minNoChars) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_min_numbers.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'min_symbols':
                    if (value.length > 0) {
                        let minNoChars = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;
                        let matches = value.match(/[^a-zA-Z0-9]/g);
                        let noMatches = matches !== null ? matches.length : 0;

                        if (noMatches < minNoChars) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_min_symbols.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'min_lowercase':
                    if (value.length > 0) {
                        let minNoChars = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;
                        let matches = value.match(/[a-z]/g);
                        let noMatches = matches !== null ? matches.length : 0;

                        if (noMatches < minNoChars) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_min_lowercase.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'min_uppercase':
                    if (value.length > 0) {
                        let minNoChars = typeof ruleConfig.value !== typeof undefined ? ruleConfig.value : 0;
                        let matches = value.match(/[A-Z]/g);
                        let noMatches = matches !== null ? matches.length : 0;

                        if (noMatches < minNoChars) {
                            ruleValid = false;
                            text = this.hm.app.messages.validation_min_uppercase.text.replace('[replace1]', ruleConfig.value);
                        }
                    }
                    break;

                case 'passwords_dont_match':
                    let repeatedValue = component.subelements.repeat.value;
                    if (value !== repeatedValue) {
                        ruleValid = false;
                    }
                    break;


            }

            if (!ruleValid) {
                this.hm.warn('rule invalid', ruleName, componentId);
                if (text === '') {
                    try {
                        text = this.hm.app.messages['validation_' + ruleName].text;
                    } catch (e) {
                        this.hm.warn('message missing', 'validation_' + ruleName, this.hm.app.messages);
                    }
                }

                if (typeof rules[ruleName].justWarn === typeof undefined || rules[ruleName].justWarn === false) {
                    valid = false;
                }

                this.invalidateForRule(component, ruleName, text, valid);
            }

        }

        this.resolveValidation(component);

        return valid;
    },

    resetValidation: function (component) {
        component.valid = true;
        component.validationResults = [];
        component.element.classList.remove('is-invalid');
        if (typeof component.subelements.validationMessage !== typeof undefined && component.subelements.validationMessage !== null) {
            let errorSubelement = component.subelements.validationMessage;
            errorSubelement.innerHTML = '';
            this.hm.helper.hideElement(errorSubelement);
        }
    },

    invalidateForRule: function (component, rule, errorText, valid) {
        component.valid = component.valid && valid;
        component.validationResults.push({
            rule: rule,
            errorText: errorText
        });
    },

    resolveValidation: function (component) {
        if (component.validationResults.length > 0) {
            let errorText = '';

            if (component.validationResults.length > 1) {
                errorText = '<ul>';

                for (let i = 0; i < component.validationResults.length; i++) {
                    errorText += '<li>' + component.validationResults[i].errorText + '</li>';
                }

                errorText += '</ul>';
            } else {
                errorText = component.validationResults[0].errorText;
            }

            component.subelements.validationMessage.innerHTML = errorText;
            this.hm.helper.showElement(component.subelements.validationMessage);
            component.element.classList.add('is-invalid');
        }
    }
};

module.exports = validator;